import { apiCall } from "../../utils/apiCall";
import { getToken } from "../../helpers/tokenHelper";

export const getFilteredTransactions = (page = 0, size = 10, filters = {}) => async (dispatch) => {
    try {
        const token = getToken();
        const headers = {
            Authorization: "Bearer ".concat(token),
        };
        
        const params = { 
            page, 
            size,
            ...(filters.msisdn && { msisdn: filters.msisdn }),
            ...(filters.transactionId && { transactionId: filters.transactionId }),
            ...(filters.startDate && { startDate: filters.startDate }),
            ...(filters.endDate && { endDate: filters.endDate })
        };
        
        const res = await apiCall.get(`/intelligrapi/transactions/filtered`, {
            params,
            headers
        });
        return res.data;
    } catch (error) {
        throw error;
    }
};
